import { useEffect, useRef, useState } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { t } from "./locale";
import "./update.css";

export default function UpdateNotice() {
  const registration = useRef<ServiceWorkerRegistration | undefined>(undefined);
  const [waiting, setWaiting] = useState(false);
  const {
    needRefresh: [needRefresh],
  } = useRegisterSW({
    immediate: true,
    onRegisteredSW(_url, value) {
      registration.current = value;
      if (value) {
        setWaiting(Boolean(value.waiting));
        void value
          .update()
          .then(() => setWaiting(Boolean(value.waiting)))
          .catch(() => {});
      }
    },
  });

  useEffect(() => {
    let active = true;
    let checking = false;
    const check = async () => {
      if (
        checking ||
        document.visibilityState !== "visible" ||
        !navigator.onLine
      )
        return;
      const value = registration.current;
      if (!value) return;
      checking = true;
      try {
        await value.update();
      } catch {
        /* Keep the current version usable offline. */
      } finally {
        checking = false;
        if (active) setWaiting(Boolean(value.waiting));
      }
    };
    const interval = setInterval(() => void check(), 60000);
    document.addEventListener("visibilitychange", check);
    window.addEventListener("focus", check);
    window.addEventListener("online", check);
    return () => {
      active = false;
      clearInterval(interval);
      document.removeEventListener("visibilitychange", check);
      window.removeEventListener("focus", check);
      window.removeEventListener("online", check);
    };
  }, []);

  if (!needRefresh && !waiting) return null;
  const current = location.pathname + location.search + location.hash;
  return (
    <aside className="app-update-notice" role="status">
      <span>{t("A new version is ready.")}</span>
      <a href={`/runtime/update.html?return=${encodeURIComponent(current)}`}>
        {t("Update now")}
      </a>
    </aside>
  );
}
